export const WidgetItemAspectRatios = ['square', '3:4', '2:3', '9:16'] as const;
export type WidgetItemAspectRatio = (typeof WidgetItemAspectRatios)[number];
export const WidgetItemAspectRatioDefault: WidgetItemAspectRatio = '2:3';

export const valueForAspecRatio = (aspect: WidgetItemAspectRatio) => {
  switch (aspect) {
    case 'square':
      return 1.0;
    case '3:4':
      return 3 / 4;
    case undefined:
    case '2:3':
      return 2 / 3;
    case '9:16':
      return 9 / 16;
  }

  throw new Error(`Unhandled aspect ratio ${aspect}`);
};
